import React from "react";
import BrandSection from "./components/BrandSection";
import assetData from "./assetData";
import "./App.css";

const App = () => {
  return (
    <div className="App">
      {assetData.map((brand, index) => (
        <BrandSection
          key={index}
          assetDetails={brand.assetDetails}
          assets={brand.assets}
        />
      ))}
      <footer>
        © {new Date().getFullYear()} Find Labs - Brand Assets Library. All
        rights reserved.
      </footer>
    </div>
  );
};

export default App;
